import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import DropdownButton from 'dpl/components/ResponsiveSelect/DropdownButton';

export default function BottomSheetMenu({
  isOpen,
  onClose,
  options,
  onSelect,
  disabled
}) {
  return (
    <FixedTooltipPortal
      className="BottomSheetMenu no-scrollbars"
      isVisible={isOpen}
      onCloseClick={onClose}
      style={{ maxHeight: '90vh' }}
      shouldHideCloseButton
    >
      <div className="font-16 fw-medium bg-white">
        <div className="flex items-center justify-center">
          <button
            className="pv3 nt4"
            type="button"
            onClick={onClose}
            disabled={disabled}
          >
            <span
              className="db br-pill bg-gray-600"
              style={{ height: '5px', width: '36px' }}
            />
          </button>
        </div>
        {options.map((option, index) => (
          <React.Fragment key={option.value}>
            <DropdownButton
              className={classnames('pv4 ph2', option.className)}
              option={option}
              onChange={onSelect}
            />
            {index !== options.length - 1 && (
              <hr className="b--solid b--gray-200 bt-0 mv1" />
            )}
          </React.Fragment>
        ))}
      </div>
    </FixedTooltipPortal>
  );
}

BottomSheetMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

BottomSheetMenu.defaultProps = {
  disabled: false
};
